import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import "./FloatingWhatsappBanner.scss";

const FloatingWhatsappBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [minimized, setMinimized] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 800); // Delay for pop-in animation
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setMinimized(true);
  };               

  return (
    <>
      {isVisible && !minimized && (
        <div className="floating-whatsapp-banner slide-up">
          <div className="floating-whatsapp-banner-content">
            <p className="floating-text">Get fit with Fitoja. Chat for your customised diet plan</p>
            <a
              href="https://wa.me/919891113123"
              target="_blank"
              rel="noopener noreferrer"
              className="floating-button"
            >
              <FaWhatsapp className="wa-icon" />
              <span className="chat-with-us-text">Chat with Us</span>
            </a>
          </div>
          <button
            className="dismiss-button"
            onClick={handleDismiss}
            aria-label="Close"
          >
            <IoClose size={20} />
          </button>
        </div>
      )}

      {/* {minimized && (
        <a
          href="https://wa.me/919891113123"
          className="floating-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp size={22} />
        </a>
      )} */}
    </>
  );
};

export default FloatingWhatsappBanner;
